module.exports = __webpack_public_path__ + "img/olympia.e786a168.png";